import Vue from 'vue';
import VueRouter from 'vue-router';
import Callback from '@/components/Callback.vue';
import Home from '@/views/Home.vue';
import LegalInformation from '@/views/LegalInformation.vue';
import Survey from '@/views/Survey.vue';
import SurveyNamespace from '@/views/SurveyNamespace.vue';
import SurveyPDF from '@/views/SurveyPDF.vue';
import SurveyResult from '@/views/SurveyResult.vue';
import Recommendation from '@/views/Recommendation.vue';
import AboutAxis from '@/views/AboutAxis.vue';
import PageNotFound from '@/views/PageNotFound.vue';
import StartASurvey from '@/views/StartASurvey.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/legalinformation',
    name: 'LegalInformation',
    component: LegalInformation,
  },
  {
    path: '/ressources',
    name: 'Recommendation',
    component: Recommendation,
    props: true,
  },
  {
    path: '/survey',
    name: 'Survey',
    component: Survey,
    meta: { protected: true },
  },
  {
    path: '/survey/start',
    name: 'StartASurvey',
    component: StartASurvey,
    meta: { protected: true },
  },
  {
    path: '/survey/edit/:id',
    name: 'EditASurvey',
    component: StartASurvey,
    meta: { protected: true },
  },
  {
    path: '/survey/:namespace/:querystring',
    name: 'SurveyNamespace',
    component: SurveyNamespace,
    meta: { protected: true },
    props: (route) => ({ query: route.query.q }),
  },
  {
    path: '/survey/:namespace/:querystring/:sessionId',
    name: 'SurveyNamespace',
    component: SurveyNamespace,
    meta: { protected: true },
    props: (route) => ({ query: route.query.q }),
  },
  {
    path: '/survey-compare/:namespace/:querystring/:sessionId/:compareSessionId',
    name: 'SurveyNamespace',
    component: SurveyNamespace,
    meta: { protected: true },
    props: (route) => ({ query: route.query.q }),
  },
  {
    path: '/survey-public/:namespace/:querystring/:sessionId',
    name: 'SurveyNamespacePublic',
    component: SurveyNamespace,
    props: (route) => ({ query: route.query.q }),
  },
  {
    path: '/surveyPDF/:namespace/:yEnterpriseSectorUserId/:sessionId',
    name: 'SurveyPDF',
    component: SurveyPDF,
    meta: { protected: false, hideFooter: true, hideHeader: true },
    props: (route) => ({ query: route.query.q }),
  },
  {
    path: '/surveyPDFpublic/:namespace/:yEnterpriseSectorUserId/:sessionId',
    name: 'SurveyPDFpublic',
    component: SurveyPDF,
    meta: { protected: false, hideFooter: true, hideHeader: true },
    props: (route) => ({ query: route.query.q }),
  },
  {
    path: '/surveyPDF-compare/:namespace/:yEnterpriseSectorUserId/:sessionId/:compareSessionId',
    name: 'SurveyPDF',
    component: SurveyPDF,
    meta: { protected: false, hideFooter: true, hideHeader: true },
    props: (route) => ({ query: route.query.q }),
  },
  {
    path: '/survey-result',
    name: 'SurveyResult',
    component: SurveyResult,
    meta: { protected: true },

  },
  {
    path: '/about-axis',
    name: 'AboutAxis',
    component: AboutAxis,
    meta: { protected: false },
  },
  {
    path: '/callback',
    component: Callback,
  },
  {
    path: '/callback/survey',
    component: Callback,
  },
  {
    path: '*',
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

export default router;
